export default {
  id: "page15",
  header: "Zgoda na testowanie produktów w warunkach domowych",

  questions: [
    {
      type: "justlabel",
      number: "28",
      label: "Testowanie produktów w warunkach domowych"
    },
    {
      label:
        "Czy zgodzi się Pan(i) na testowanie jakiegokolwiek produktu w warunkach domowych? Proszę zaznaczyć jedną wybraną odpowiedź",

      type: "radio",
      id: "ankieta_zgodaTestyDom",
      required: false,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    },
    {
      id: "respondent_adres",
      number: "28a",
      show: [["ankieta_zgodaTestyDom", "==='1'"]],
      label: "Adres domowy (ulica, nr domu/mieszkania)",
      type: "text",
      required: true,
      validations: { minLength: 5, maxLength: 255 }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/config/page15.js